import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { loginUser } from '../api';
import { trackLogin } from '../analytics';
import useAuthStore from '../store/authStore';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { setToken, loadUser } = useAuthStore();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await loginUser(username, password);
      setToken(res.data.token);
      await loadUser();
      trackLogin(username);
      navigate('/');
      window.scrollTo(0, 0);
      // Reset any iOS Safari zoom that was triggered by the login inputs
      document.querySelector('meta[name=viewport]').setAttribute(
        'content', 'width=device-width, initial-scale=1, viewport-fit=cover'
      );
    } catch (err) {
      setError(err.response?.data?.non_field_errors?.[0] || 'Login failed');
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg)',
    }}>
      <div style={{
        background: 'var(--bg2)', border: '1px solid var(--border)',
        borderRadius: 16, padding: 40, width: '100%', maxWidth: 400,
        boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>🎵</div>
          <h1 style={{ fontSize: 24, fontWeight: 700, margin: 0 }}>bbmusicmix</h1>
          <p style={{ color: 'var(--text-muted)', marginTop: 8, fontSize: 14 }}>Sign in to your account</p>
        </div>

        {error && (
          <div style={{
            background: 'rgba(255,50,50,0.15)', border: '1px solid rgba(255,50,50,0.3)',
            borderRadius: 8, padding: '10px 14px', marginBottom: 20,
            color: '#ff6b6b', fontSize: 13,
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 13, color: 'var(--text-muted)', marginBottom: 6 }}>
              Username
            </label>
            <input
              className="search-input"
              style={{ width: '100%', boxSizing: 'border-box' }}
              value={username}
              onChange={e => setUsername(e.target.value)}
              autoFocus
            />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={{ display: 'block', fontSize: 13, color: 'var(--text-muted)', marginBottom: 6 }}>
              Password
            </label>
            <input
              className="search-input"
              style={{ width: '100%', boxSizing: 'border-box' }}
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
          </div>
          <button
            className="btn btn-primary"
            style={{ width: '100%', padding: '10px', fontSize: 15 }}
            type="submit"
            disabled={loading}
          >
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: 'var(--text-muted)' }}>
          Have an invite code?{' '}
          <Link to="/register" style={{ color: 'var(--accent)' }}>Create account</Link>
        </p>
        <p style={{ textAlign: 'center', marginTop: 8, fontSize: 13, color: 'var(--text-muted)' }}>
          <Link to="/forgot-password" style={{ color: 'var(--text-muted)' }}>Forgot password?</Link>
        </p>
      </div>
    </div>
  );
}